import { render } from "./MainActivity.vue?vue&type=template&id=6d1fe7d5"
import script from "./MainActivity.vue?vue&type=script&lang=js"
export * from "./MainActivity.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./MainActivity.vue?vue&type=style&index=0&id=6d1fe7d5&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__